<template>
  <div>
    <programmeSimulation
      v-if="programmeSimulationShow"
      ref="programmeSimulation"
      :items="animation.animationData"
      :groups="animation.groups"
      :initCustomDate="animation.initCustomDate"
      :maxTime="animation.maxTime"
      :loading="animation.loading"
      :returnTime="true"
      :isOperate="false"
      @shutDown="shutDown"
      @animationNodes="animationNodes"
      @resetTime="resetTime"
      @suspended="suspended"
      @removeTimer="removeTimer"
      @mouseUp="mouseUp"
      @returnTimeFun="returnTimeFun"
      @endTimeFun="endTimeFun"
      doubleSpeed="week"
      title="时间轴"
      containerWidth="83%"
      containerLeft="14"
    ></programmeSimulation>
  </div>
</template>
<script>
const programmeSimulation = () =>
  import("@/components/tables/Timeline/programmeSimulation.vue");
import screenplayFn from "@/components/tables/program/screenplayFn.js";
import * as mapWork from "@/components/tables/animation/map.js";
export default {
  name: "constructionSimulationIndex",
  components: { programmeSimulation },
  data() {
    return {
      animation: {},
      programmeSimulationShow: false,
    };
  },
  computed: {},
  props: {},
  watch: {},
  filters: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  methods: {
    shutDown(e) {
      mapWork.init(false);
      // this.programmeSimulationShow = false;
    },
    animationNodes(e) {
      console.log("componentDyeing", e);
      let removeData, Obj;
      e.add.forEach((index) => {
        Obj = e.items.find((key) => key.id == index);
        if (Obj)
          Obj.screenplay.forEach((i) => {
            screenplayFn[i.type][i.executionProperty](
              i.property,
              i.screenplayId
            );
          });
      });

      e.remove.forEach((i) => {
        // 移除时间块的操作需要 人为处理 所以不取 i.executionProperty
        removeData = e.items.find((item) => item.id == i);
        removeData.screenplay.forEach((i) => {
          mapWork.removeTimeBlock(
            i.property,
            i.screenplayId,
            i.executionProperty
          );
        });
      });
    },
    returnTimeFun(t) {
      // console.log(t);
    },
    resetTime(e) {
      console.log("resetTime", e);
      mapWork.init();
    },
    removeTimer(e) {
      console.log("removeTimer", e);
    },
    mouseUp(e) {
      console.log("mouseUp", e);
    },
    suspended(e) {
      console.log("suspended", e);
    },
    endTimeFun(t) {
      mapWork.init();
    },
    initAnimation(animation) {
      this.animation = animation;
      this.programmeSimulationShow = true;
    },
    destroyedAnimation() {
      this.programmeSimulationShow = false;
    },
    init() {
      mapWork.getInitAnimation(this.initAnimation, this.destroyedAnimation);
    },
  },
  mounted() {
    //实例被挂载后调用，这时 el 被新创建的 vm.el 替换了。如果根实例挂载到了一个文档内的元素上，
    //当 mounted 被调用时 vm.el 也在文档内。
    this.init();
  },
  watch: {},
  destroyed() {
    this.animation = [];
    mapWork.init();
  },
};
</script>
<style lang="scss" scoped></style>
